import { createAsyncThunk } from "@reduxjs/toolkit";
import { admin_apiEndpoint, config_variable } from "../../helper/commonApi";
import { GetApiCall, ApiCall } from "../../helper/axios";

export const getPriceUpdateLogAsync = createAsyncThunk('fetch/getPriceUpdateLog', async (params, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    let url = `/price-update-logs?shop=${config_variable.shop_name}`;
    const { page, search, sort, status } = params;
    if (sort) {
        url += `&sort=${sort}`;
    }
    if (status) {
        url += `&status=${status}`;
    }
    if (page) {
        url += `&page=${page}`;
    }
    if (search) {
        url += `&search=${search}`;
    }
    const res = await GetApiCall('GET', url, { authentication: store_data?.token })
    if (res.data.success && res.status === 200) {
        return res?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

export const deletePriceUpdateLogAsync = createAsyncThunk('fetch/deletePriceUpdateLog', async (params, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await ApiCall('DELETE', `/price-update-logs?shop=${config_variable.shop_name}`, params.payload, { authentication: store_data?.token });
    if (res.data.success && res.status === 200) {
        params.callback(res.data.success, res?.data?.message);
        return res?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

